import gql from 'graphql-tag';

export const createOrgMutation = gql`
  mutation createOrganization($requestCreateOrganizations: RequestCreateOrganizations!) {
    createOrganization(requestCreateOrganizations: $requestCreateOrganizations) {
      orgId
    }
  }
`;
